import { Box, styled } from '@mui/material';

export const LayoutContainer = styled(Box)`
  display: flex;
  margin-top: 16px;
  margin-bottom: 10px;
`;

export const ScreensContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const LayoutTypeContainer = styled(Box)`
  margin-right: 40px;
`;

export const ScreenBox = styled(Box)(
  ({ theme, height, width }) => `
    height: ${height}px;
    width: ${width}px;
    border: 4px solid ${theme.palette.common.black};
    background: ${theme.palette.brand.screenLightBlue};
    margin-right: -3px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
);
